(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function () {
            return factory();
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        root.levels = factory();
    }
})(this, function () {
    'use strict';
    /**
     * Log level heirarchy.
     * @type {Object}
     */
    return {
        none: 10000,
        global: 10000, // in case global gets through somehow
        error: 40,
        exception: 40,
        warn: 30,
        info: 20,
        dir: 10,
        dirxml: 10,
        debug: 10,
        log: 10
    };
});
